function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import PolygonIcon from 'svg/polygon.svg';
import InjectionIcon from 'svg/injection.svg';
import messages from '../messages';
import * as shapes from '../shapes';
import Time from '../partials/Time';
import styles from '../RelatedData.pcss';
var _React_PureComponent;
class InjectionTooltip extends (_React_PureComponent = React.PureComponent) {
    get type() {
        const { injection } = this.props;
        if (injection.name === 'Long-acting Insulin' || injection.basalFlag) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.longActing));
        }
        if (injection.name === 'Fast-acting Insulin' || injection.bolusFlag) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.fastActing));
        }
        return injection.name;
    }
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(InjectionIcon, {
                    className: styles.relatedDataTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__titleText,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.label)),
                        ' ',
                        "(",
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.injection.labels.injectionUnit)),
                        ")"
                    ]
                })
            ]
        });
    }
    renderInjection() {
        const { injection } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__detailType,
                    children: this.type
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__detailValue,
                    children: injection.value
                })
            ]
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__details,
            children: [
                this.renderInjection(),
                /*#__PURE__*/ _jsx(Time, {
                    timeSeriesResource: this.props.injection
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.relatedDataTooltip,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.relatedDataTooltip__content,
                children: [
                    this.renderTitle(),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.relatedDataTooltip__separator
                    }),
                    this.renderDetails(),
                    /*#__PURE__*/ _jsx(PolygonIcon, {
                        width: "17",
                        height: "12",
                        className: styles.relatedDataTooltip__polygon
                    })
                ]
            })
        });
    }
}
_define_property(InjectionTooltip, "propTypes", {
    // Explicit props
    injection: shapes.injection.isRequired
});
export default withStyles(styles)(InjectionTooltip);
